import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ExternalDependencyLoader {
    constructor(private http: HttpClient) { }

    // region Methods
    public load(callback, ...urls) {
        let count = 0;
        for (const url of urls) {
            let element;
            if (url.endsWith('.js')) {
                element = document.createElement('script');
                element.src = url;
                element.type = 'text/javascript';
                element.async = true;
            }
            if (url.endsWith('.css')) {
                element = document.createElement('link');
                element.rel = 'stylesheet';
                element.href = url;
            }
            if (callback) {
                element.addEventListener('load', function () {
                    count++;
                    if (count === urls.length) {
                        callback(urls);
                    }
                });
            }
            document.getElementsByTagName('head')[0].appendChild(element);
        }
    }
    // endregion
}



// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/services/external-dependency-loader.service.ts